import React from 'react';
import { ModalContext } from '@europrocurement/flexy-components';
import { SousClientApi, useSociete, useTiersService } from '@europrocurement/l2d-domain';
import { PrescriberClientForm } from '@europrocurement/l2d-modules/modules/PrescriberClient';

type UseEditSousClientOptions = {
    sousClientId: number | undefined;
    onSuccess?: () => void;
};

const useEditSousClient = ({ sousClientId, onSuccess }: UseEditSousClientOptions) => {
    const { modalActions } = React.useContext(ModalContext);
    const { sousClientsApi } = useTiersService();
    const xIdSociete = useSociete();

    const handleCancel = () => {
        modalActions.close();
    };

    const handleSuccess = async () => {
        try {
            modalActions.close();
            onSuccess?.();
        } catch (error) {
            console.error('Erreur lors de la mise à jour:', error);
        }
    };

    const openPrescriberClientForm = (sousClient: SousClientApi) => {
        modalActions.call(
            <PrescriberClientForm
                onCancel={handleCancel}
                onSuccess={handleSuccess}
                sousClient={sousClient}
            />,
        );
    };

    const editFolio = async () => {
        if (!sousClientId) return;
        const sousClient = await sousClientsApi.getTiersTiersItem({
            id: sousClientId as unknown as string,
            xIdSociete,
        });
        openPrescriberClientForm(sousClient?.data as SousClientApi);
    };

    return { editFolio };
};

export default useEditSousClient;
